import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import {
  APPROVE_MEMBER_EVENTS,
  MEMBER_EVENTS_DETAIL,
} from 'manager/http-constants';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { ApprovalDialogComponent } from '../common/approval-dialog/approval-dialog.component';
import { PlatformComponent } from '../platform.component';
import { LoginService } from 'src/app/shared/service/login.service';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';

@Component({
  selector: 'app-e102',
  templateUrl: './e102.component.html',
  styleUrls: ['./e102.component.scss', '../platform.component.scss'],
})



/**
 * 会員主催イベント詳細(E102)
 */
export class E102Component extends PlatformComponent {
  /** 共通部品_承認時ダイアログ */
  @ViewChild(ApprovalDialogComponent)
  approvalDialogComponent: ApprovalDialogComponent;

  // 会員主催イベント詳細情報
  memberEventData: any;

  // 会員主催イベントID
  memberEventId = this.route.snapshot.params.member_event_id;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private messageData: MessageData,
    private location: Location,
    private loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  async ngOnInit(): Promise<void> {

    await this.getUserLogin();
    // 会員主催イベント情報リスト取得
    this.getMemberEventData();
  }
  /**
   * イベント区分(event_kbn)
   * 1=会員主催イベント
   * 2=分科会からのお知らせ
   * 3=会員からのお知らせ
   * 4=分科会主催イベント
   */

  /**
   * 会員主催イベント情報リスト取得
  */
  public getMemberEventData(): void {
    // 会員主催イベントIDを取得
    console.log(this.route.snapshot.params.member_event_id);
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(MEMBER_EVENTS_DETAIL);

    // 会員主催イベント申請検索結果を取得
    this.dbOperationService
      .getNoTemplateDisplayData(MEMBER_EVENTS_DETAIL, this.memberEventId, true)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, MEMBER_EVENTS_DETAIL);

        if (this.commonService.checkNoneResponse(response)) {
          // 警告メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );

          // 前画面へ戻る
          this.location.back();
        } else {
          // 会員主催イベント情報リストを格納
          this.memberEventData = response.body;
          if( !this.decisionPerspective(this.memberEventData.member_id) &&
            !this.decisionSecretariat() && this.memberEventData.status.id != '2'
          ){
            // 異常メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
                position: TOAST.BOTTOM_RIGHT,
                life: 60000,
              })
            );
            this.loginService.logout(MESSAGE_CODE.N90001);
            return;
          }
        }
      });

  }

  /**
   * 会員主催イベント申請登録(E104)へ遷移する
   * @param memberEventId 会員主催イベント申請ID
  */
  public moveE104(memberEventId: string): void {
    // 会員主催イベント申請登録(E104)へ遷移
    this.router.navigate(['pages/platform/e104/edit'], {
      queryParams: {
        screenId: 'e104',
        member_event_id: this.memberEventId,
      },
    });
  }

  /**
   * 内閣府承認ダイアログ表示
  */
  public openSmallApprovalDialog(): void {
    // 内閣府承認ダイアログ表示
    this.approvalDialogComponent.openSmallApprovalDialog(
      APPROVE_MEMBER_EVENTS,
      this.memberEventId,
      2005,
      0
    );
  }

  async getUserLogin(){
    return new Promise(resolve => {
      this.loginService.getAuth0LoginState().subscribe((response) => {
        // ログイン状態をセット

        // ログイン状態を判定
        if (response) {
          // ログイン状態の場合

          /* ログインユーザー情報 */
          // セッションからログインユーザ情報取得
          const loginUser = JSON.parse(
            window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
          );

          // セッションにログインユーザ情報が存在するか否か
          if (loginUser) {
            // セッションにログインユーザが存在する場合

            // 課題・ソリューション結果を取得
            return resolve(null);
          } else {
            // セッションにログインユーザが存在しない場合(初回表示時)

            // ログインユーザ情報取得処理
            this.loginService.getLoginUser().subscribe((response) => {
              // 正常なユーザの為、セッションにユーザ情報を格納
              window.sessionStorage.setItem(
                SESSION_KEY.loginUserInformation,
                JSON.stringify(response.body[0])
              );

              this.loginUser = JSON.parse(window.sessionStorage.getItem(SESSION_KEY.loginUserInformation));
              // 課題・ソリューション結果を取得
              return resolve(null);
            });
          }
        } else {
          // 未ログイン状態の場合

          return resolve(null);
        }
      });
    });
  }
}
